// extracted by mini-css-extract-plugin
export default {"formGroup":"CheckboxFormField_formGroup__tfX01"};